/** Locale + currency helpers. Prices are in minor units (qəpik). */
export function formatAZN(minor, locale = "az") {
  if (minor == null) return "";
  const value = minor / 100;
  /* Whole manats stay whole, but a price with qəpik shows them: the amount on
     screen must equal the amount charged, not its rounding. */
  const hasFraction = minor % 100 !== 0;
  const formatted = new Intl.NumberFormat(locale === "az" ? "az-AZ" : "en-US", {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: hasFraction ? 2 : 0,
  }).format(value);
  return `${formatted} ₼`;
}

export function pickLocale(dict, locale = "az") {
  if (!dict) return "";
  return dict[locale] || dict.az || dict.en || "";
}
